import React from 'react';
import { Download } from 'lucide-react';

import EWave from '../assets/wallpapers/EWave.svg';
import SND from '../assets/wallpapers/SND.svg';
import SNR from '../assets/wallpapers/SNR.svg';
import SNRBO from '../assets/wallpapers/SNRBO.svg';
import SUPPLY from '../assets/wallpapers/SUPPLY.svg';
import VNW2N01 from '../assets/wallpapers/VNW2N01.svg';
import Wave from '../assets/wallpapers/wave.svg';
import MarketStructure from '../assets/wallpapers/2RgXJ01.svg';
import Crypto from '../assets/wallpapers/Crypto.svg';
import Candles from '../assets/wallpapers/candlestick-doodles.svg';
import Demand from '../assets/wallpapers/dEMAND.svg';
import TradingLevels from '../assets/wallpapers/trading-levels.svg';
import ChatPattern from '../assets/wallpapers/chat-pattern.svg';

const wallpapers = [
    { id: 'market-structure', name: 'Market Structure', src: MarketStructure },
    { id: 'crypto', name: 'Crypto Market', src: Crypto },
    { id: 'candles', name: 'Candlestick Patterns', src: Candles },
    { id: 'ewave', name: 'Elliott Wave Theory', src: EWave },
    { id: 'snd', name: 'Supply & Demand', src: SND },
    { id: 'snr', name: 'Support & Resistance', src: SNR },
    { id: 'snrbo', name: 'Support & Resistance Breakout', src: SNRBO },
    { id: 'supply', name: 'Supply Zones', src: SUPPLY },
    { id: 'demand', name: 'Demand Zones', src: Demand },
    { id: 'trading-levels', name: 'Trading Levels', src: TradingLevels },
    { id: 'vnw', name: 'VNW Pattern', src: VNW2N01 },
    { id: 'wave', name: 'Wave Analysis', src: Wave },
    { id: 'chat-pattern', name: 'Bull & Bear Pattern', src: ChatPattern },
];

const Wallpapers = () => {
    const handleDownload = async (src, name) => {
        try {
            const response = await fetch(src);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${name.replace(/\s+/g, '-').toLowerCase()}.svg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    return (
        <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
            <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Trading Wallpapers & Cheatsheets</h1>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                    High-quality reference charts and wallpapers for your trading setup.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {wallpapers.map((wallpaper) => (
                    <div
                        key={wallpaper.id}
                        className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden hover:shadow-md transition-shadow"
                    >
                        <div className="aspect-[16/9] p-4 bg-gray-100 dark:bg-gray-700/50 flex items-center justify-center overflow-hidden">
                            <img
                                src={wallpaper.src}
                                alt={wallpaper.name}
                                className="w-full h-full object-contain hover:scale-105 transition-transform duration-300"
                            />
                        </div>

                        <div className="p-4 flex items-center justify-between">
                            <h3 className="font-medium text-gray-900 dark:text-white truncate" title={wallpaper.name}>
                                {wallpaper.name}
                            </h3>

                            <button
                                onClick={() => handleDownload(wallpaper.src, wallpaper.name)}
                                className="p-2 text-gray-500 hover:text-[#30C4B5] hover:bg-[#30C4B5]/10 rounded-lg transition-colors"
                                title="Download Wallpaper"
                            >
                                <Download size={20} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Wallpapers;
